<template>
  <div class="system-settings app-info-list app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-row type="flex" align="middle">
      <a-col>账号名称</a-col>
      <a-col>
        <a-row type="flex" align="middle">
          <a-col>{{$store.state.userInfo.username}}</a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" align="middle">
      <a-col>账号姓名</a-col>
      <a-col>
        <a-row type="flex" align="middle">
          <a-col>{{$store.state.userInfo.name}}</a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" align="middle">
      <a-col>账号密码</a-col>
      <a-col>
        <a-row type="flex" align="middle">
          <a-col>******</a-col>
          <a-col>
            <a-button type="link" @click="showModal">修改</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-modal v-model="modal.show" :title="modal.title" ok-text="确认" cancel-text="取消" @ok="handleModal" destroy-on-close>
      <change-password ref="changePassword"></change-password>
    </a-modal>
  </div>
</template>

<script>
  import ChangePassword from '@/views/common/ChangePassword.vue';

  export default {
    name: 'SystemSettings',
    data() {
      return {
        modal: {
          title: '修改密码',
          show: false
        }
      }
    },
    components: {
      ChangePassword,
    },
    methods: {
      showModal() {
        this.modal.show = true;
      },
      handleModal() {
        this.$refs.changePassword.submit(() => {
          this.modal.show = false;
          this.logout();
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>